import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import moment from 'moment';

import { profileApi } from 'src/api';

import { setProfileErrors } from './profile.slice';

import { normalizeErrorResponse } from 'src/utils';

export const getProfile = createAsyncThunk('profile/get-user-profile', async () => {
  try {
    const response = await profileApi.getUserProfile();

    localStorage.setItem('profile', response?.data);

    const orders = response?.data?.orders.sort((a, b) => {
      const dateA = moment(a.created_at);
      const dateB = moment(b.created_at);

      return dateB.valueOf() - dateA.valueOf();
    });

    return { ...response?.data, orders };
  } catch (error) {
    localStorage.removeItem('profile');

    console.error(error);
  }
});

export const updateProfile = createAsyncThunk(
  'profile/update-user-profile',
  async (data, thunkApi) => {
    try {
      const response = await profileApi.updateUserProfile(data);

      thunkApi.dispatch(getProfile());

      toast(response?.message, { type: 'success', position: 'top-right' });

      thunkApi.dispatch(setProfileErrors({}));

      return response;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setProfileErrors(normalizeErrorResponse(response?.data?.errors)));
    }
  },
);
